import {BaseEntity} from "../../entities/BaseEntity";
import {PagingModel} from "./PagingModel";
import {IService} from "../../services/IService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Template} from "../../entities/Template";
import {GridBookmark} from "../../entities/GridBookmark";

export class AdminPagingModel<T extends BaseEntity> extends PagingModel<T> {
    constructor($q: ng.IQService, pagingService: IService, notificationService: NotificationService,
                public gridBookmarkService:GridBookmarkService) {
        super($q, pagingService, notificationService);
    }

    getPagedPromise(): ng.IPromise<any> {
        this.savePagination();
        return super.getPagedPromise();
    }

    print(template: Template) {

    }

    handleCustomAction(actionName: string): ng.IPromise<void> {
        return this.$q.when();
    }

    getCustomActions(): string[] {
        return [];
    }

    printTemplateType(): string {
        return "Asset";
    }

    entityName(): string {
        return "";
    }

    displayName(): string {
        return "";
    }

    addEditAllowed(): boolean {
        return true;
    }

    deleteAllowed(): boolean {
        return true;
    }

    deleteEnabled(): boolean {
        return this.selectedItems.length > 0 && this.deleteAllowed();
    }

    addEditEnabled(): boolean {
        return this.selectedItems.length > 0 && this.addEditAllowed();
    }

    delete(ids: number[]): ng.IPromise<boolean> {
        return this.pagingService.delete(ids);
    }

    paginationInfoAvailable(): boolean {
        var gridBookmark: GridBookmark = this.gridBookmarkService.getBookmark(this.entityName());
        return (gridBookmark != null && GridBookmarkService.isRecent(gridBookmark));
    }

    savePagination() {
        // Store page settings before getting data
        var gridBookmark = new GridBookmark(this.page, this.pageSize, this.search, this.orderColumn, this.orderDirection, Date.now());
        this.gridBookmarkService.setBookmark(this.entityName(), gridBookmark);
    }

    recallPagination() {
        // Recall page settings
        var gridBookmark: GridBookmark = this.gridBookmarkService.getBookmark(this.entityName());
        if (gridBookmark != null && GridBookmarkService.isRecent(gridBookmark)) {
            this.page = gridBookmark.page;
            this.pageSize = gridBookmark.pageSize;
            this.search = gridBookmark.search;
            this.orderColumn = gridBookmark.orderColumn;
            this.orderDirection = gridBookmark.orderDirection;
        }
    }
}
